import { FormControlProps } from '../ui/FormControl';
import { SelectProps } from '../ui/Select';
import { SelectDateField } from './SelectDateField';

const dayOptions = Array.from({ length: 31 }, (v, k) => ({
  label: (k + 1).toString(),
  value: (k + 1).toString().padStart(2, '0'),
}));

const monthOptions = [
  { label: '1 - jan', value: '01' },
  { label: '2 - fev', value: '02' },
  { label: '3 - mar', value: '03' },
  { label: '4 - abr', value: '04' },
  { label: '5 - mai', value: '05' },
  { label: '6 - jun', value: '06' },
  { label: '7 - jul', value: '07' },
  { label: '8 - ago', value: '08' },
  { label: '9 - set', value: '09' },
  { label: '10 - out', value: '10' },
  { label: '11 - nov', value: '11' },
  { label: '12 - dez', value: '12' },
];

const baseYear = new Date().getFullYear() - 18;

const yearOptions = Array.from({ length: 120 }, (v, k) => ({
  label: (baseYear - k).toString(),
  value: (baseYear - k).toString(),
}));

export type SelectDateFieldBirthdateProps = Omit<FormControlProps, 'name' | 'label'> &
  SelectProps & {
    name?: string;
    label?: string;
  };

export const SelectDateFieldBirthdate = (props: SelectDateFieldBirthdateProps) => {
  return (
    <SelectDateField
      name="birthdate"
      label="Data de nascimento"
      dayOptions={dayOptions}
      monthOptions={monthOptions}
      yearOptions={yearOptions}
      {...props}
    />
  );
};
